const accountPage = {
  key: 'accountPage',
  name: 'Account Page',
  siteIdentifier: 'petsafe',

  title: 'Account | PetSafe',
};

exports.accountPage = accountPage;
